import { internallID, MARKER_POPUP_OBJECT } from "@repo/map-helpers";

export function findInternalIDByExternalID(id: string) {
  for (let obj of internallID) {
    if (
      obj.geoFaIds.includes(id.toString()) ||
      obj.guideDenmarkIds.includes(id.toString())
    ) {
      return obj.id as keyof typeof MARKER_POPUP_OBJECT;
    }
  }
  // default
  return "29" as keyof typeof MARKER_POPUP_OBJECT;
}
